import Vue from "vue";
import VueRouter from "vue-router";
// 没啥子用
import Login from "./pages/login.vue";
import Signup from "./pages/signup.vue";
import Forgotpassword from './pages/password-forgot.vue';
// 首页
import home from "../view/newsHome/index.vue";
import news from "../view/newsHome/news/index.vue";
import newsDetail from "../view/newsHome/news/detail.vue";
import questionDetail from "../view/newsHome/homeComponents/questionDetail.vue";
// 业务介绍
import business from "../view/business/index.vue";
import sea from "../view/business/tab/sea.vue"
import air from "../view/business/tab/air.vue"
import road from "../view/business/tab/road.vue"
// 全球网络
import globalNetwork from "../view/globalNetwork/index.vue";
// 平台专区
import platform from "../view/platform/index.vue"
import warehouseMap from "../view/platform/tab/warehouseMap.vue"
import AMAZON from "../view/platform/tab/AMAZON.vue"
import AMZDetail from "../view/platform/tab/components/AMZDetail.vue"
// 关于我们
import about from "../view/about/index.vue"
import inviteJob from "../view/about/components/inviteJob.vue"
import inviteList from "../view/about/components/inviteList.vue"
import inviteListDetail from "../view/about/components/inviteListDetail.vue"
import corporateCulture from "../view/about/components/corporateCulture.vue"
import connection from "../view/about/components/connection.vue"
// 开发对接
import developmentDocking from "../view/developmentDocking/index.vue"
import mainComponents from '../view/developmentDocking/mainComponents.vue';
Vue.use(VueRouter);

const routes = [
  {
    path: "/newsHome",
    name: "newsHome",
    component: home
  },
  {
    path: "/questionDetail",
    name: "questionDetail",
    component: () => import('../view/newsHome/homeComponents/questionDetail.vue')
  },
  {
    path: "/news",
    name: "news",
    component: () => import('../view/newsHome/news/index.vue')
  },
  {
    path: "/newsDetail",
    name: "newsDetail",
    component: () => import('../view/newsHome/news/detail.vue')
  },
  {
    path: "/business",
    name: "business",
    component: () => import('../view/business/index.vue'),
  },
  {
    path: "/sea",
    name: "sea",
    component: () => import('../view/business/tab/sea.vue'),
  },
  {
    path: "/air",
    name: "air",
    component: () => import('../view/business/tab/air.vue'),
  },
  {
    path: "/road",
    name: "road",
    component: () => import('../view/business/tab/road.vue'),
  },
  {
    path: "/globalNetwork",
    name: "globalNetwork",
    component: () => import('../view/globalNetwork/index.vue')
  },
  {
    path: "/platform",
    name: "platform",
    component: () => import('../view/platform/index.vue')
  },
  {
    path: "/warehouseMap",
    name: "warehouseMap",
    component: () => import('../view/platform/tab/warehouseMap.vue')
  },
  {
    path: "/AMAZON",
    name: "AMAZON",
    component: () => import('../view/platform/tab/AMAZON.vue')
  },
  {
    path: "/AMZDetail",
    name: "AMZDetail",
    component: () => import('../view/platform/tab/components/AMZDetail.vue')
  },
  {
    path: "/about",
    name: "about",
    component: () => import('../view/about/index.vue')
  },
  {
    path: "/connection",
    name: "connection",
    component: () => import('../view/about/components/connection.vue')
  }, 
  {
    path: "/corporateCulture",
    name: "corporateCulture",
    component: () => import('../view/about/components/corporateCulture.vue')
  }, 
  {
    path: "/inviteJob",
    name: "inviteJob",
    component: () => import('../view/about/components/inviteJob.vue')
  },
  {
    path: '/developmentDocking',
    name: "developmentDocking",
    component: () => import('../view/developmentDocking/index.vue'),
    children: [
      {
        path: 'main',
        name: 'mainComponents',
        component: mainComponents
      }
    ]
  },
  {
    path: "/inviteList",
    name: "inviteList",
    component: () => import('../view/about/components/inviteList.vue')
  },
  {
    path: "/inviteListDetail",
    name: "inviteListDetail",
    component: () => import('../view/about/components/inviteListDetail.vue')
  },
  {
    path: '/join',
    redirect: '/join/social',
  },
  {
    path: '/join/:tab',
    component: () => import('@/view/join/index.vue'),
    name: 'join',
    meta: {
      login: true,
      title: true
    }
  },
  {
    path: "/login",
    name: "Login page",
    component: () => import('./pages/login.vue')
  },
  {
    path: "/signup",
    name: "Signup page",
    component: () => import('./pages/signup.vue')
  },
  {
    path: '/customerNotice',
    name: 'customerNotice',
    component: () => import('../view/customerNotice/index.vue')
  },
  {
    path: '*', // 捕获所有不匹配的路径
    redirect: '/newsHome' // 重定向到/home
  }
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes
});
// const originalPush = router.push;

// // 重写 router.push 方法
// router.push = function push(location, onResolve, onReject) {
//   if (onResolve || onReject) {
//     return originalPush.call(this, location, onResolve, onReject);
//   }
//   return originalPush.call(this, location).catch(err => err);
// }
export default router;
